module.exports = __webpack_public_path__ + "static/media/wisepalFacebook-1200x630.79e3a24f.jpg";